import { defineBlock, smartProps, useInspectorControl, useEditor } from '@smartfire/js-block-engine'
import style from './block.module.scss'
import React, { useRef, useEffect } from 'react'
import clsx from 'clsx'

import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'

const Inspector = React.lazy(() => import('./Inspector.js'))

function Map({ lng, lat, zoom, mapboxKey }) {
    useInspectorControl(Inspector)
    const { isEditing } = useEditor()
    const mapContainer = useRef(null)
    const map = useRef(null)

    useEffect(() => {
        mapboxgl.accessToken = mapboxKey
        if (map.current || !mapboxgl.accessToken) return // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/smartfire/clb3yh2lf000114ntsxg7w6zi',
            center: [parseFloat(lng), parseFloat(lat)],
            zoom: parseFloat(zoom),
        })

        map.current = new mapboxgl.Marker({ color: style.blue })
            .setLngLat([parseFloat(lng), parseFloat(lat)])
            .addTo(map.current)
    })

    return (
        <div className={style.blockMap}>
            {mapboxKey ? (
                <div ref={mapContainer} className={clsx(style.map, isEditing && style.editor)} />
            ) : (
                <>
                    {isEditing && (
                        <p className={style.editingTextMap}>
                            Insérez votre clé MapBox dans apparence &gt; Personnalisation &gt;
                            SmartfireBlock pour afficher la carte. La carte s'affichera dans le
                            front dès qu'elle sera ajoutée.
                        </p>
                    )}
                </>
            )}
        </div>
    )
}

export default defineBlock({
    Block: Map,
    smartProps: {
        lng: smartProps.string.withDefault(0),
        lat: smartProps.string.withDefault(0),
        zoom: smartProps.string.withDefault(1),
    },
    setup: {
        title: 'Map',
        parent: ['smartfire/contact'],
    },
})
